<template>
  <v-layout row align-center class="fab-container" v-if="contentId">
    <nx-round-button
      v-if="isDirty && !finished"
      :color="hasErrors ? 'error' : 'accent'"
      :disabled="disabled || hasErrors"
      :loading="loading"
      @click.native="save"
      icon="save"
    ></nx-round-button>

    <nx-round-button
      v-if="!isDirty && !finished"
      color="accent"
      :disabled="disabled"
      :loading="loading"
      @click.native="finish"
      icon="done"
    ></nx-round-button>

    <nx-round-button
      v-if="finished"
      color="primary"
      :disabled="disabled"
      :loading="loading"
      @click.native="unlink"
      icon="delete"
    ></nx-round-button>

  </v-layout>
</template>

<script>
import NxRoundButton from '@/components/buttons/RoundButton';
import { mapState, mapGetters } from 'vuex';

export default {
  components: {
    NxRoundButton,
  },
  props: {
    disabled: Boolean,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('milenium', ['finished', 'flags', 'contentId']),
    ...mapGetters('milenium', ['isDirty']),
    hasErrors() {
      if (this.flags && this.flags.valid === false) return true;
      return false;
    },
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        await this.$store.dispatch('milenium/SAVE', this.contentId);
      } finally {
        this.loading = false;
      }
    },
    async finish() {
      try {
        this.loading = true;
        await this.$store.dispatch('milenium/FINISH', this.contentId);
      } finally {
        this.loading = false;
      }
    },
    async unlink() {
      try {
        this.loading = true;
        await this.$store.dispatch('milenium/UNLINK', this.contentId);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>


<style lang="stylus" scoped>
.fab-container {
  position: absolute;
  bottom: -32px;
  right: 0;
  padding-right: 18px;
}
</style>
